import {
  axiosInstance,
  axiosPostInstance,
} from "application/axios/axios-instance";

import { getMarket } from "application/functions";

const storeID = getMarket();

const setAppointment = (storeId, appointment) =>
  axiosPostInstance.post(
    `/itxrest/1/store/${storeId}/guest-user/appointments`,
    appointment
  );

const getAvailability = (params) => {
  const appointmentType =
    params && params.appointmentType && params.appointmentType !== ""
      ? params.appointmentType
      : "";
  const stlocId =
    params && params.stlocId && params.stlocId !== "" ? params.stlocId : "";
  return axiosInstance.get(
    `/itxrest/1/store/${storeID}/availability?appointmentType=${appointmentType}&stlocId=${stlocId}`
  );
};

export default {
  setAppointment,
  getAvailability,
};
